
export const baseURL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";


export const LoginURL = `${baseURL}/auth/login`;

export const AddPollURL = `${baseURL}/addPoll`;

export const GetPollURL = `${baseURL}/getPollsUser`;

export const GetPollWithUserIdURL = `${baseURL}/getPollUserWithId`;

export const EditPollURL = `${baseURL}/updatePoll`;

export const GetPollsAdminURL = `${baseURL}/getPollsAdmin`;

export const DeletePollURL = `${baseURL}/deletePoll/`;

export const GetPdfURL = `${baseURL}/pdf`;

export const GetUsersURL = `${baseURL}/users`;

export const AddUserURL = `${baseURL}/addUser`;

export const UpdateUserURL = `${baseURL}/updateUser/`;

export const DeleteUserURL = `${baseURL}/deleteUser/`;

export const ChangePasswordURL = `${baseURL}/changePassword/`;

export const GetBulletinURL = `${baseURL}/bulletins`;

export const SendNoteToEmailURL = `${baseURL}/sendNote`;

export const GetTeamLeadsURL = `${baseURL}/teamLeads`;

export const OptLunchURL = `${baseURL}/optLunch`;

export const GetLunchOptedUsersURL = `${baseURL}/lunchOptedUsers`;

export const GetJournalsURL = `${baseURL}/journals`;

export const AddJournalURL = `${baseURL}/addJournal`;

export const DeleteJournalURL = `${baseURL}/deleteJournal/`;

export const GetTeamJournalsURL = `${baseURL}/teamJournals`;

export const AddTLFeedbackURL = `${baseURL}/tlFeedback/`;

export const ActionURL = `${baseURL}/actions/`;

export const GetAllJournalsURL = `${baseURL}/allJournals`; 